import { createFileRoute } from "@tanstack/react-router";
import { LegalPage, legalHead } from "@/pages/LegalPage";
import { persondataStrings } from "@/i18n/content/legal";

export const Route = createFileRoute("/persondatapolitik")({
  head: () => legalHead("persondata", "da", persondataStrings.da.meta),
  component: () => <LegalPage {...persondataStrings.da} />,
});
